import { render, staticRenderFns } from "./page-promocodes.vue?vue&type=template&id=b1fe28b0&"
import script from "./page-promocodes.vue?vue&type=script&lang=ts&"
export * from "./page-promocodes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports